import {
  GET_NSO_RECEIPT_REQUEST,
  GET_NSO_RECEIPT_RESPONSE,
  GET_NSO_RECEIPT_ERROR,
} from 'actions/sendABox';

const initialState = {
  isLoading: false,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_NSO_RECEIPT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_NSO_RECEIPT_RESPONSE:
      return {
        ...state,
        isLoading: false,
        data: action.response,
        error: null,
      };
    case GET_NSO_RECEIPT_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error || null,
      };
    default:
      return state;
  }
};

export const selectReceipt = state => state.data;
export const selectReceiptLoading = state => state.isLoading;
export const selectReceiptError = state => state.error;

export const selectMealPricing = state => {
  const receiptData = state.data;
  return receiptData?.mealPricing || [];
};
